module.exports = __webpack_public_path__ + "static/media/Group 2523.e577b64d.svg";